import { render, staticRenderFns } from "./newsStory.vue?vue&type=template&id=307c9f94&scoped=true"
import script from "./newsStory.vue?vue&type=script&lang=js"
export * from "./newsStory.vue?vue&type=script&lang=js"
import style0 from "./newsStory.vue?vue&type=style&index=0&id=307c9f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307c9f94",
  null
  
)

export default component.exports